import { render, staticRenderFns } from "./contactMadeToMeasure.vue?vue&type=template&id=3611e982&"
import script from "./contactMadeToMeasure.vue?vue&type=script&lang=js&"
export * from "./contactMadeToMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports